export default defineNuxtRouteMiddleware(async (to) => {
  // Only apply to /administrace/* routes
  if (!to.path.startsWith('/administrace')) return

  if (import.meta.server) return

  const { checkSession, isAuthenticated, isAuthReady, isEmailVerified } = useAuth()

  if (isAuthReady.value && isAuthenticated.value) {
    // Session exists, check email verification
    const verified = await isEmailVerified()
    if (!verified) {
      return navigateTo('/zkontroluj-email')
    }
    return
  }

  const hasSession = await checkSession()
  if (!hasSession) {
    return navigateTo(`/prihlaseni?redirect=${encodeURIComponent(to.fullPath)}`)
  }

  // Session exists, check email verification
  const verified = await isEmailVerified()
  if (!verified) {
    return navigateTo('/zkontroluj-email')
  }
})
